module.exports = __webpack_public_path__ + "media/images/_anim2-8ae1f6bf47e9c01372f16d22ed119b18.gif";